<template>
<el-dialog :title="mainDialog.title" :visible.sync="mainDialog.visible" width="50%">
  <div class="dialog-body">
    <div class="handle-box">
      <el-button type="primary" icon="el-icon-plus" class="handle-del mr10" @click="showEditHall({store_id:store_id}, 'create')">厅</el-button>
      <el-input v-model="query.title" placeholder="厅名称" clearable class="handle-input mr10"></el-input>
      <el-button class="btn-search" type="primary" icon="el-icon-search" @click="getTableData">搜索</el-button>
    </div>
    <el-table :data="tableData" ref="multipleTable" highlight-current-row v-loading="loading" border>
      <el-table-column prop="id" align="center" label="编号" width="80"></el-table-column>
      <el-table-column prop="title" label="厅名称"></el-table-column>
      <el-table-column label="操作" width="220">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="showEditHall(scope.row, 'edit')">编辑</el-button>
          <el-button type="danger" size="mini" @click="deleteHall(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination @size-change="changeLimit" @current-change="changePage" :current-page="pagination.page" :page-size="pagination.limit" :page-sizes="[10, 30, 50, 100]" layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
    </div>

    <edit-hall ref="editHall" :parent="_self"></edit-hall>
  </div>
</el-dialog>
</template>

<script>
import dictionary from '@/utils/dictionary.js';
import editHall from './edit.vue';

export default {
  props: {
    parent: {}
  },
  components: {
    editHall
  },
  data() {
    return {
      store_id: 0,
      loading: false,
      mainDialog: {
        title: '厅管理',
        visible: false
      },
      query: {
        id: '',
        title: '',
        city_id: ''
      },
      tableData: [],
      pagination: {
        page: 1,
        limit: 10,
        total: 0
      }
    };
  },
  beforeMount() {
    this.dictionary = dictionary;
  },
  methods: {
    // 编辑账号信息
    show(row) {
      this.mainDialog.title = row.title + '厅管理';
      this.mainDialog.visible = true;
      this.store_id = row.id;
      this.getTableData();
    },
    getTableData() {
      this.loading = true;
      let url = '/api/dictionary.hall/index';
      let query = {
        ...this.query
      };
      query['store_id'] = this.store_id;
      query['pagination'] = this.pagination;
      this.$post(url, query).then(res => {
        this.tableData = res.data.list;
        this.pagination = res.data.pagination;
        this.loading = false;
      });
    },
    changeLimit(limit) {
      this.pagination.limit = limit;
      this.getTableData();
    },
    changePage(page) {
      this.pagination.page = page;
      this.getTableData();
    },
    showEditHall(row, type) {
      if (this.$refs['editHall']) {
        this.$refs['editHall'].showDialog(row, type);
      } else {
        this.$nextTick(function () {
          this.$refs['editHall'].showDialog(row, type);
        });
      }
    },
    deleteHall(id) {
      let _this = this;
      this.$confirm('确定删除此账号么, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let url = '/api/dictionary.hall/delete'
        _this.$post(url, {id:id}).then(res => {
          _this.getTableData();
          _this.$message({
            type: 'success',
            message: '删除成功!'
          });
        });

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import url('@/assets/css/common.less');
.dialog-body {
  padding: 12px 20px;
  box-sizing: border-box;
}
</style>
